import React, { useState, useEffect, useReducer, useContext, useRef } from "react";

import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { useStyles } from "./ContactsStyles";
import useContacts from "./useContacts";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import Avatar from "@material-ui/core/Avatar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import Checkbox from "@material-ui/core/Checkbox";
import GetAppIcon from "@material-ui/icons/GetApp";
import { getProfilePicUrl } from "../../services/api";
import { getContact } from "../../services/contacts.api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ContactProfile360Modal from "../../components/ContactProfile360Modal";
import ConfirmationModal from "../../components/ConfirmationModal/";
import ImportContactsResultModal from "../../components/ImportContactsResultModal";
import CancelIcon from "@material-ui/icons/Cancel";
import { i18n } from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { SocketContext } from "../../context/Socket/SocketContext";
import { generateColor } from "../../helpers/colorGenerator";
import { getInitials } from "../../helpers/getInitials";




const Contacts = () => {
  const classes = useStyles();
  const {
    actionType,
    confirmOpen,
    contactCount,
    contactModalOpen,
    contactTicket,
    contacts,
    deletingContact,
    dispatch,
    fileUploadRef,
    getDateLastMessage,
    hadleEditContact,
    handleCheckAgenda,
    handleCloseContactModal,
    handleCloseOrOpenTicket,
    handleCloseProfile360,
    handleDeleteContact,
    handleDeleteSelectedContacts,
    handleDownloadTemplate,
    handleExportSelectedContacts,
    handleOpenContactModal,
    handleSearch,
    handleSelectAll,
    handleSelectContact,
    handleimportContact,
    history,
    importResult,
    importResultModalOpen,
    loading,
    newTicketModalOpen,
    page,
    profile360Open,
    rowsPerPage,
    searchParam,
    selectAll,
    selectedContactId,
    selectedContacts,
    setActionType,
    setConfirmOpen,
    setContactCount,
    setContactModalOpen,
    setContactTicket,
    setDeletingContact,
    setImportResult,
    setImportResultModalOpen,
    setLoading,
    setNewTicketModalOpen,
    setPage,
    setProfile360Open,
    setRowsPerPage,
    setSearchParam,
    setSelectAll,
    setSelectedContactId,
    setSelectedContacts,
    setTotalCount,
    socketManager,
    totalCount,
    user,
    forceUpdate,
  } = useContacts();

  return (
    <MainContainer className={classes.mainContainer}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactProfile360Modal
        open={profile360Open}
        onClose={handleCloseProfile360}
        contactId={selectedContactId || undefined}
        onContactUpdated={async () => {
          if (!selectedContactId) return;
          try {
            const { data } = await getContact(selectedContactId, {
              params: { _t: Date.now(), _nocache: true }
            });
            if (data && data.id) {
              dispatch({ type: "UPDATE_CONTACTS", payload: data });
              forceUpdate((n) => n + 1);
            }
          } catch (_) {
            /* noop */
          }
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
        onSave={(saved) => {
          if (!saved || typeof saved !== "object" || !saved.id) return;
          dispatch({ type: "UPDATE_CONTACTS", payload: saved });
          forceUpdate((n) => n + 1);
        }}
      />
      <ImportContactsResultModal
        open={importResultModalOpen}
        onClose={() => {
          setImportResultModalOpen(false);
          setImportResult(null);
        }}
        result={importResult}
      />
      <ConfirmationModal
        title={
          deletingContact
            ? `${i18n.t("contacts.confirmationModal.deleteTitle")} ${
                deletingContact.name
              }?`
            : actionType === "import"
            ? `${i18n.t("contacts.confirmationModal.importTitle")}`
            : actionType === "export" && selectedContacts.length > 0
            ? selectedContacts.length === contacts.length && contacts.length >= totalCount && totalCount > 0
              ? i18n.t("contacts.confirmationModal.titleExportAll")
              : selectedContacts.length === 1
              ? i18n.t("contacts.confirmationModal.titleExportOne")
              : i18n.t("contacts.confirmationModal.titleExportMany", {
                  count: selectedContacts.length,
                })
            : selectedContacts.length > 0
            ? selectedContacts.length === contacts.length && contacts.length >= totalCount && totalCount > 0
              ? `${i18n.t("contacts.confirmationModal.deleteAllTitle")}`
              : selectedContacts.length === 1
              ? i18n.t("contacts.confirmationModal.titleDeleteOne")
              : i18n.t("contacts.confirmationModal.titleDeleteMany", {
                  count: selectedContacts.length,
                })
            : `${i18n.t("contacts.confirmationModal.importTitle")}`
        }
        open={confirmOpen}
        onClose={() => {
          setConfirmOpen(false);
          setActionType("");
          setContactCount(0);
        }}
        onConfirm={(e) => {
          if (deletingContact) {
            handleDeleteContact(deletingContact.id);
          } else if (actionType === "import") {
            // ✅ CORREGIR: Priorizar importación cuando actionType es "import"
            // Esto puede ser desde archivo (fileUploadRef) o desde agenda (contactCount > 0)
            handleimportContact();
          } else if (actionType === "export" && selectedContacts.length > 0) {
            handleExportSelectedContacts();
          } else if (selectedContacts.length > 0) {
            // ✅ Solo borrar si NO hay acción de importación pendiente
            handleDeleteSelectedContacts();
          } else {
            handleimportContact();
          }
        }}
      >
        {deletingContact
          ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
          : actionType === "import"
          ? contactCount > 0
            ? i18n.t("contacts.confirmationModal.importAgendaMessage").replace('{count}', contactCount)
            : fileUploadRef.current?.files?.[0]
            ? `${i18n.t("contacts.confirmationModal.importMessage")} ${fileUploadRef.current.files[0].name}`
            : `${i18n.t("contacts.confirmationModal.importMessage")}`
          : actionType === "export" && selectedContacts.length > 0
          ? selectedContacts.length === contacts.length && contacts.length >= totalCount && totalCount > 0
            ? i18n.t("contacts.confirmationModal.exportConfirmAll")
            : i18n.t("contacts.confirmationModal.exportConfirmMany", {
                count: selectedContacts.length,
              })
          : selectedContacts.length > 0
          ? selectedContacts.length === contacts.length && contacts.length >= totalCount && totalCount > 0
            ? `${i18n.t("contacts.confirmationModal.deleteAllMessage")}`
            : i18n.t("contacts.confirmationModal.deleteSelectedMany", {
                count: selectedContacts.length,
              })
          : `${i18n.t("contacts.confirmationModal.importMessage")}`}
      </ConfirmationModal>
      <MainHeader>
        <Title>
          {i18n.t("contacts.title")}
          <span style={{ 
            marginLeft: '12px', 
            fontSize: '0.85em', 
            fontWeight: 'normal', 
            color: '#666',
            backgroundColor: '#e3f2fd',
            padding: '4px 10px',
            borderRadius: '16px',
            border: '1px solid #90caf9'
          }}>
            {totalCount}{" "}
            {totalCount === 1
              ? i18n.t("contacts.badge.contact")
              : i18n.t("contacts.badge.contacts")}
          </span>
        </Title>
        <MainHeaderButtonsWrapper>
          <TextField
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleCheckAgenda}
          >
            {i18n.t("contacts.buttons.import")}
          </Button>
                    <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // ✅ CORREGIR: Limpiar selección de contactos antes de importar para evitar confusión
              setSelectedContacts([]);
              setSelectAll(false);
              fileUploadRef.current.value = null;
              fileUploadRef.current.click();
            }}
      >
        {i18n.t("contacts.buttons.importSheet")}
      </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenContactModal}
          >
            {i18n.t("contacts.buttons.add")}
          </Button>

          <Button
            variant="contained"
            color="secondary"
            disabled={selectedContacts.length === 0}
            onClick={() => {
              setActionType("delete");
              setConfirmOpen(true);
            }}
          >
            {i18n.t("contacts.buttons.delete")}
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (selectedContacts.length === 0) {
                toast.error(i18n.t("contacts.messages.selectToExport"));
                return;
              }
              setActionType("export");
              setConfirmOpen(true);
            }}
          >
            {i18n.t("contacts.buttons.export")}
          </Button>
          <IconButton
            color="primary"
            onClick={handleDownloadTemplate}
            title={i18n.t("contacts.buttons.downloadTemplate")}
            style={{ marginLeft: '8px' }}
          >
            <GetAppIcon />
          </IconButton>

        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper
        className={classes.mainPaper}
        variant="outlined"
      >
        <>
          <input
              style={{ display: "none" }}
              id="upload"
              name="file"
              type="file"
              accept=".xls,.xlsx"
              onChange={() => {
                // ✅ CORREGIR: Configurar actionType para importar y limpiar selección de contactos
                // Esto evita que se confunda con la acción de borrar cuando hay contactos seleccionados
                setActionType("import");
                setSelectedContacts([]); // Limpiar selección para evitar confusión
                setSelectAll(false);
                setConfirmOpen(true);
              }}
              ref={fileUploadRef}
          />
        </>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                  indeterminate={selectedContacts.length > 0 && selectedContacts.length < contacts.length}
                />
              </TableCell>
              <TableCell>{i18n.t("contacts.table.profile")}</TableCell>
              <TableCell>{i18n.t("contacts.table.name")}</TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.whatsapp")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.email")}
              </TableCell>
              <TableCell align="center">
              {i18n.t("contacts.table.lastInteraction")}
              </TableCell>
			  <TableCell align="center">{i18n.t("contacts.table.status")}</TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.actions")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {contacts.map((contact) => (
                <TableRow key={`row-${contact.id}-${contact.profilePicUrl || 'no-pic'}-${contact.name}`}>
                  <TableCell style={{ paddingRight: 0 }}>
                    <Checkbox
                      checked={selectedContacts.includes(contact.id)}
                      onChange={() => handleSelectContact(contact.id)}
                    />
                  </TableCell>
                  <TableCell style={{ paddingRight: 0 }}>
                    <Avatar
                      style={{ backgroundColor: generateColor(contact?.number), fontWeight: "bold", color: "white" }}
                      src={contact.profilePicUrl && !contact.profilePicUrl.includes("nopicture.png") ? `${getProfilePicUrl(contact.profilePicUrl)}?v=${Date.now()}` : null}>
                      {getInitials(contact?.name)}
                    </Avatar>
                  </TableCell>
                  <TableCell>{contact.name}</TableCell>
                  <TableCell align="center">{contact.number}</TableCell>
                  <TableCell align="center">{contact.email}</TableCell>
                                    <TableCell align="center">
                                        {getDateLastMessage(contact)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {contact.active ? (
                                            <CheckCircleIcon
                                                style={{ color: "green" }}
                                                fontSize="small"
                                            />
                                        ) : (
                                            <CancelIcon
                                                style={{ color: "red" }}
                                                fontSize="small"
                                            />
                                        )}
                                    </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={() => {
                        setContactTicket(contact);
                        setNewTicketModalOpen(true);
                      }}
                    >
                      <WhatsAppIcon />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => hadleEditContact(contact.id)}
                    >
                      <EditIcon />
                    </IconButton>
                    <Can
                      role={user.profile}
                      perform="contacts-page:deleteContact"
                      yes={() => (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            setConfirmOpen(true);
                            setDeletingContact(contact);
                          }}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton avatar columns={3} />}
            </>
          </TableBody>
        </Table>
        
        {!loading && totalCount > 0 && (
          <TablePagination
            component="div"
            count={totalCount}
            page={page}
            onPageChange={(event, newPage) => {
              setPage(newPage);
            }}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 15, 20, 30, 50, 100]}
            labelRowsPerPage={i18n.t("contacts.pagination.rowsPerPage")}
            labelDisplayedRows={({ from, to, count }) =>
              i18n.t("contacts.pagination.displayedRows", {
                from,
                to,
                count: count !== -1 ? count : to,
              })
            }
            style={{
              backgroundColor: 'transparent',
              color: 'inherit',
            }}
          />
        )}
      </Paper>
    </MainContainer>
  );
};

export default Contacts;
